export function normalizeBorderRadius( value ) {
	let borderRadiusValues = [],
		borderRadiusString = ''

	if ( value.includes( ',' ) ) {
		borderRadiusValues = value.split( ',' )
	} else {
		borderRadiusValues = value.split( ' ' )
	}

	borderRadiusValues = borderRadiusValues.filter( Boolean ).map( item => {
		return item.includes( 'px' ) || item.includes( '%' ) ? item : item + 'px'
	} )
	borderRadiusString = borderRadiusValues.join( ' ' )

	return borderRadiusString
}



// WEBPACK FOOTER //
// ./utilities/normalize.jsx